import type { FormTabType } from '@/app/types';
import { reportEvent } from '@/app/utils';

export * from './temp-images';

/**
 * formType 到路由的映射
 */
const FORM_TYPE_TO_ROUTE_MAP: Record<FormTabType, string> = {
  text2video: '/create/text2video',
  img2video: '/create/img2video',
  character2video: '/create/character2video',
  text2image: '/create/text2image',
  reference2image: '/create/reference2image',
  scene: '/create/scene',
};

/**
 * 根据 formType 获取目标路由
 */
export const getTargetRouteByFormType = (formType: FormTabType): string => {
  return FORM_TYPE_TO_ROUTE_MAP[formType] || '/create';
};

/**
 * 根据 pathname 获取页面类型
 * @param pathname 路径名
 * @returns 页面类型
 */
export const getPageType = (pathname: string) => {
  if (pathname.includes('/ai-text-to-video')) return 'text to video';
  if (pathname.includes('/ai-image-to-video')) return 'image to video';
  if (pathname.includes('/ai-reference-to-video')) return 'reference to video';
  if (pathname.includes('/ai-image-generator')) return 'image generator';
  if (pathname.includes('/vidu-q3')) return 'vidu q3';
  if (pathname.includes('/vidu-q3-vs-seedance-2-0-vs-kling-3-0')) return 'vidu q3 vs seedance 2-0 vs kling 3-0';
  return '';
};

/**
 * 上报产品页面的元素点击事件
 * @param element 元素名称
 */
export const reportProductPageElementClick = (element: string) => {
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
  reportEvent('feature_element_click', {
    element,
    from_page: getPageType(pathname),
  });
};
